export default __webpack_public_path__ + "static/real-time-data-updates-888c43c791069f33b1e723de551308db.png";